import { LoadingComponent } from '@blaze-cms/react-page-builder';

const LoadingOverlay = () => (
  <div className="blaze-ecommerce-loading-overlay">
    <LoadingComponent />
  </div>
);

export default LoadingOverlay;
